import { moment } from "@/config/vue/plugins/moment.js";
import jwtDecode from "jwt-decode";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    unitSelected: null, 
    token: null,
    user: null,
    sessionTimeLeftMs: null,
    sessionTimeoutNotificationMs: 0,
  },
  mutations: {
    setUnitSelected(state, unitSelected) {
      state.unitSelected = unitSelected;
    },
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setSessionTimeLeftMs(state, sessionTimeLeftMs) {
      state.sessionTimeLeftMs = sessionTimeLeftMs;
    },
    setSessionTimeoutNotificationMs(state, sessionTimeoutNotificationMs) {
      state.sessionTimeoutNotificationMs = sessionTimeoutNotificationMs;
    },
  },
  actions: {
    clearToken(context) {
      context.commit("setToken", null);
      context.commit("setUser", null);
      context.commit("setUnitSelected", null);
    },
    unauthenticated(context) {
      context.dispatch(
        "createNotification",
        {
          message: "Seu login expirou!",
          type: "warning",
        },
        { root: true }
      );

      context.dispatch("clearToken");

      const route = router.app.$route;

      if (route.path.includes("/login")) return;

      router.push({
        path: "/login",
        query: { redirectTo: route.fullPath },
      });
    },

    resetPassword(context, resetPasswordParams) {
      return new Promise((resolve, reject) => {
        window.axios
          .post("/users/password", {
            user: resetPasswordParams,
          })
          .then(function(response) {
            console.log("context", context);
            context.dispatch("createNotification", {
              message: "Você receberá instruções no email caso esteja cadastrado.",
              type: "error",
            });
            resolve(response);
          })
          .catch(function(error) {
            console.log(error);
            reject(error);
          });
      });
    },

    signIn(context, loginParams, unitSelected) {
      console.log('sign', unitSelected)
      return new Promise((resolve, reject) => {
        window.axios
          .post("/users/sign_in", {
            user: {
              ...loginParams,
            }
          })
          .then(function(response) {
            context.commit("setToken", response.headers.authorization);
            context.commit("setUser", response.data);
            context.dispatch("authorization/loadAuthorizationsFromUser", null, { root: true });

            context.commit("setUnitSelected", { id: loginParams["unit_id"] });
            resolve(response);
          })
          .catch(function(error) {
            console.log(error);
            reject(error);
          });
      });
    },
    signOut(context) {
      return new Promise((resolve, reject) => {
        window.axios
          .get("/users/sign_out", {
            headers: {
              Authorization: context.state.token,
            },
          })
          .then(function(response) {
            resolve(response);

            context.dispatch("clearToken");
          })
          .catch(function(error) {
            console.log(error);
            reject(error);
          });
      });
    },
   refreshToken(context) {
      return new Promise((resolve, reject) => {
        window.axios
          .post('/refresh_token', {},
            {
            headers: {
              Authorization: `${context.state.token}`, 
            },
          }
          )
          .then(function(response) {
            context.commit('setToken', `Bearer ${response.data.access_token}`); 
            resolve(response);
          })
          .catch(function(error) {
            console.error('Erro ao atualizar o token:', error);
            reject(error);
          });
      });
    },
    updateSessionTimeLeft(context) {
      const expirationTimeStr = context.getters.tokenPayload?.exp;
      const expirationTime = moment(Number(expirationTimeStr) * 1000);

      const now = moment();

      context.commit("setSessionTimeLeftMs", expirationTime.diff(now));
    },
    setSessionTimeoutNotification(context, timeInSeconds) {
      const sessionTimeoutNotificationMs = timeInSeconds * 1000;
      context.commit(
        "setSessionTimeoutNotificationMs",
        sessionTimeoutNotificationMs
      );
    },
  },
  modules: {},
  getters: {
    tokenPayload(state) {
      if (state.token) {
        return jwtDecode(state.token);
      }

      return null;
    },
    isCloseToSessionTimeout(state) {
      if (!state.sessionTimeLeftMs) return false;

      return state.sessionTimeLeftMs < state.sessionTimeoutNotificationMs;
    },
  },
};
